import { render, staticRenderFns } from "./Models.vue?vue&type=template&id=6f9dd7c6"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"
import style0 from "./Models.vue?vue&type=style&index=0&id=6f9dd7c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports